module.exports = __webpack_public_path__ + "media/images/admin/icons/terminal-62314645ceb01c471ab4fcc6d5137b5d.svg";